import { render, staticRenderFns } from "./TabelaLeituraMateriais.vue?vue&type=template&id=b9260338&scoped=true&"
import script from "./TabelaLeituraMateriais.vue?vue&type=script&lang=js&"
export * from "./TabelaLeituraMateriais.vue?vue&type=script&lang=js&"
import style0 from "./TabelaLeituraMateriais.vue?vue&type=style&index=0&id=b9260338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9260338",
  null
  
)

export default component.exports